import { useState } from 'react';
import useGeneralApiCall from 'components/Dashboard/apiCalls/useGeneralApiCall';
import createNotification from 'components/Settings/Utilities/CreateNotification';

const useEditEmailSignature = () => {
  const { generalApiCall } = useGeneralApiCall();
  const [isLoading, setIsLoading] = useState(false);

  const editEmailSignature = async ({ senderEmailAddressId, displayName, signature }) => {
    setIsLoading(signature === null ? 'delete' : 'save');
    let method = 'post';
    let pathname = '/api/email-domain/update-sender-email-address';
    let requestProperties = {
      senderEmailAddressId,
      displayName,
      signature,
    };
    let successMessage = 'Signature updated';

    const result = await generalApiCall({
      method,
      pathname,
      requestProperties,
      needsAuthentication: true,
      returnCompleteRequest: true,
    });
    if (result) {
      createNotification('success', successMessage);
      setIsLoading(false);
      return true;
    }
    setIsLoading(false);
  };

  return {
    isLoading,
    editEmailSignature,
  };
};

export default useEditEmailSignature;
